export const PRODUCTS_BASE_ACTIONS = {
  VIEW: 'PRODUCTS_BASE_VIEW',
  LIST: 'PRODUCTS_BASE_LIST',
  PRINT_EPC: 'PRODUCTS_BASE_PRINT_EPC',
  DELETE_EPC: 'PRODUCTS_BASE_DELETE_EPC',
  DIFFERENCE_ZONE_TAGS: 'PRODUCTS_BASE_DIFFERENCE_ZONE_TAGS',
  UPDATE_ALL: 'PRODUCTS_BASE_UPDATE_ALL',
  UPDATE: 'PRODUCTS_BASE_UPDATE',
  SET_DEFECTIVE: 'PRODUCTS_BASE_SET_DEFECTIVE',
  TRANSFER: 'PRODUCTS_BASE_TRANSFER'
};